import React from 'react';
import UploadDocuments from '../components/UploadDocuments';
import { Step } from '../types';
import BankConnectionStandalone from '../components/BankConnectionStandalone/BankConnectionStandalone';
import Guarantor from '../components/Guarantor';

export const StepComponents: Record<Step, React.ComponentType> = {
  enable_banking: BankConnectionStandalone,
  guarantors: Guarantor,
  upload_documents: UploadDocuments,
};
